if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

 const qty = parseInt(document.querySelector('input[name="quantity"]')?.value || '1', 10);
const mainId = this.variantIdInput?.value;

const properties = {};
document.querySelectorAll('[name^="properties["]').forEach((el) => {
  const match = el.name.match(/^properties\[(.+?)\]$/);
  if (match && el.value !== '') {
    properties[match[1]] = el.value;
  }
});

const optionIdMap = {
  'お得な"風鎮"付き': '43054689615960'
};

const setIdMap = {
      '風鎮＆防虫香（1箱10袋入り）セット': '43054689648728'
};
        
const items = [];

// 🔽 プロパティの値から商品IDを特定して追加
const optionValue = properties['オプション']; // ← ここは実際のプロパティキー
if (optionValue && optionIdMap[optionValue]) {
  items.push({ id: optionIdMap[optionValue], quantity: qty,
    properties: {
      '_uniqueId': new Date().getTime().toString()
    }, });
}

const setValue = properties['セット']; // ← ここも同様に
if (setValue && setIdMap[setValue]) {
  items.push({ id: setIdMap[setValue], quantity: qty,
    properties: {
      '_uniqueId': new Date().getTime().toString()
    }, });
}
items.push({
    id: mainId,
    quantity: qty,
    properties: {
      '_uniqueId': new Date().getTime().toString()
    },
    ...(Object.keys(properties).length > 0 && { properties })
  });
fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  body: JSON.stringify({ items })
})
  .then((res) => {
    if (!res.ok) return res.json().then(err => Promise.reject(err));
    return res.json();
  })
  .then(() => {
    window.location.href = window.routes.cart_url;
  })
  .catch((err) => {
    console.error('カート追加エラー:', err);
    this.handleErrorMessage(err.description || 'カートへの追加に失敗しました');
  })
  .finally(() => {
    this.submitButton.classList.remove('loading');
    this.submitButton.removeAttribute('aria-disabled');
    this.querySelector('.loading__spinner').classList.add('hidden');
  });

}




      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
